import React, { useEffect } from 'react';
import '../styles/tennis-betting.css';

const TennisBettingPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918000047833?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/918000047833?text=${encodedMessage}`;

  return (
    <div className="tennis-betting-page">
      <section className="tennis-betting-intro">
        <div className="tennis-betting-intro-content">
          <h1><span>Mahadev Tennis Betting:</span> Bet on Every Smash, Serve, and Set</h1>
          <p>
            Dive into the fast-paced world of tennis betting with Mahadev! From thrilling Grand Slam showdowns to gripping ATP and WTA clashes, we bring every rally to life with real-time betting opportunities. Experience the game beyond the screen—bet smarter, play bolder.
          </p>
          <div className="tennis-betting-cta-buttons">
            <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
              Open Your Demo Account
            </a>
            <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
              Contact Us Now
            </a>
          </div>
        </div>

        <div className="tennis-betting-intro-image">
          <img src="/tennis-betting.webp" alt="Tennis Betting Excitement" className="tennis-image" />
        </div>
      </section>

      <section className="tennis-betting-features">
        <h2>Top Features of <span>Mahadev Tennis Betting</span></h2>
        <ul>
          <li>
            <strong>Wide Match Coverage:</strong> From the Grand Slams to challenger circuits, bet on every level of professional tennis.
          </li>
          <li>
            <strong>Live Betting Thrill:</strong> Place bets mid-match with updated odds and ride the momentum of every point.
          </li>
          <li>
            <strong>Beginner-Friendly UI:</strong> Easy navigation, real-time updates, and quick access to live events – built for all users.
          </li>
          <li>
            <strong>In-Depth Stats & Predictions:</strong> Access exclusive insights and analytics to make informed bets.
          </li>
          <li>
            <strong>Safe & Instant Transactions:</strong> Enjoy fast deposits and withdrawals backed by robust security protocols.
          </li>
          <li>
            <strong>Play with Control:</strong> Set your limits, take breaks, and play responsibly with our built-in tools.
          </li>
        </ul>
        <div className="tennis-betting-cta-buttons">
          <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Open Your Demo Account
          </a>
          <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Contact Us Now
          </a>
        </div>
      </section>

      <section className="tennis-betting-getting-started">
        <h2><span>Your Winning Game Starts Here</span></h2>
        <p>
          At Mahadev Tennis, we go beyond basic betting. We’re here to support you with expert guidance, real-time assistance, and round-the-clock support. Whether you’re making your first bet or strategizing for a tournament, we’ve got your back.
        </p>
        <p>
          Join now to access a world of tennis betting where every game is a chance to test your knowledge, skill, and luck. Get your demo account and experience unmatched excitement with Mahadev Tennis.
        </p>
      </section>

      <section className="tennis-betting-join">
        <h2>Join <span>Mahadev Tennis</span> and Elevate Your Play</h2>
        <p>
          Make every match count with Mahadev. Competitive odds, user-first design, and complete transparency—this is tennis betting done right. Bet smart. Bet live. Bet with Mahadev.
        </p>
        <div className="tennis-betting-cta-buttons">
          <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Open Your Demo Account
          </a>
          <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Contact Us Now
          </a>
        </div>
      </section>
    </div>
  );
};

export default TennisBettingPage;
